// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from "react-router-dom";
import jwtDecode from 'jwt-decode';

// Import Icons
import NotificationIcon from '../../../../../../src/assets/icons/dasboardIcons/notification-icon.svg';
import ConfigureIcon from '../../../../../../src/assets/icons/dasboardIcons/configure-icon.svg';

// Import Material UI
import Popper from '@material-ui/core/Popper';
import Button from '@material-ui/core/Button';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { Box, CircularProgress, FormControl, MenuItem, Select, styled, Tab, Tabs, TextField, Typography, withStyles } from '@material-ui/core';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import RefreshIcon from '@material-ui/icons/Refresh';

// Import Pages
import NotificationService from '../../../../../services/NotificationService/NotificationService';
import DashBoardService from '../../../../../services/DashBoardService/DashBoardService';
import DashBoardNotifications from '../Notifications/DashBoardNotifications';

// Import Recoil
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { unreadNotificationCount, alertState, pendingListState, inProgressListState, personalizationState } from '../../../../../recoil-store/recoil-state';

// Import Services
import QueueService from '../../../../../services/QueueService/QueueService';

// Import Helper
import { convertToDateFormat, createNewFlow, getUserDetailFromJwt } from "../../../../../helpers/helper"


const CustomTabs = withStyles({
    root: {
        backgroundColor: 'white',
        borderRadius: 8,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        minHeight: 32,
    },
    indicator: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        '&::after': {
            content: '""',
            width: '40%', // Çizginin genişliği (istediğiniz değeri buraya girin)
            height: 3, // Çizginin yüksekliği
            borderRadius: 3,
            backgroundColor: '#0B2949', // Çizginin rengi
        },
    },
})(Tabs);

const CustomTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        minWidth: 100,
        minHeight: 33, // Sets the minimum height to 33px
        height: 33, // Sets the height to 33px
        fontWeight: theme.typography.fontWeightMedium,
        // marginRight: theme.spacing(1),
        letterSpacing: "0.01em",
        color: '#BEBEBE',
        '&$selected': {
            color: '#4F6E90',
            fontWeight: theme.typography.fontWeightBold,
        },
        '&:hover': {
            color: '#4F6E90',
            opacity: 1,
        },
    },
    selected: {}, // This is necessary for the `&$selected` rule to work
}))(Tab);

/**
 * @Description This function lets you return Dashboard component.
 * @Returns     Component
 * @Author      Emirhan Bilal Yeşil
 */
function DashBoardHeader({ setOpenConfigure, openConfigure, dashBoardTabs, handleCreateDashboard, dateShowValue,
    setDateShowValue, selectedDashboard, setSelectedDashboard, fetchDashboardWidgets, handleOpenRemove, customDateValue,
    setCustomDateValue, updateDashboardDate, handleOpenConfigure, handleRefresh, loading }) {

    const { t } = useTranslation();
    const label = 'CONTENT.DASHBOARD.';
    // Initial states
    const [quickInfo, setQuickInfo] = useState({ alertCount: 0, availableAutoms: 0, inProgressAutoms: 0, queueCount: 0 });
    const [notifications, setNotifications] = useState([{ title: "Automf1d2f4d1f2", description: "completed" }]);
    const [userName, setUserName] = useState("");
    const [lastLoginTime, setLastLoginTime] = useState("");
    const navigate = useNavigate();
    const setAlert = useSetRecoilState(alertState);
    const count = useRecoilValue(unreadNotificationCount);
    const pendingList = useRecoilValue(pendingListState);
    const inProgressList = useRecoilValue(inProgressListState);
    const personalization = useRecoilValue(personalizationState);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorCustomDate, setAnchorCustomDate] = useState(null);

    // Fetch data on start
    useEffect(() => {
        const userToken = localStorage.getItem("userName");
        let userName = JSON.parse(JSON.stringify(userToken));
        userName = userName.replace(/"/g, '');
        setUserName(userName)
        let lastLogin = getUserDetailFromJwt();
        // if (lastLogin && lastLogin.role && lastLogin.role.length) {
        //     if (lastLogin.role.find(x => x.id === admin_user_id)) {
        //         setAdvancedLogs(true);
        //     } else {
        //         setAdvancedLogs(false);
        //     }
        // } else {
        //     setAdvancedLogs(false);
        // }
        if (lastLogin.login_time) {
            setLastLoginTime(lastLogin.login_time)
        }
        fetchData();

        const intervalId = setInterval(fetchData, 20000);

        return () => clearInterval(intervalId);
    }, []);

    const fetchData = async () => {
        const response = await DashBoardService.getQuickInformations()
        if (response.status) {
            if (response.data) {
                setQuickInfo((pre) => {
                    return {
                        ...pre, availableAutoms: response.data.availableAutoms,
                        inProgressAutoms: response.data.inProgressAutoms,
                        queueCount: response.data.queueCount,
                        alertCount: response.data.alertCount,
                    }
                });
            }
        }

    };

    const fetchNotificationData = async () => {
        let notifications = [], pending = 0;
        let res = await NotificationService.getNotifications(true);
        if (res?.status && res.data) { notifications = res.data; };
        res = await QueueService.getQueueStatus(['PENDING']);
        if (res?.status && res.data) { pending = res.data.count; }
        setQuickInfo((pre) => {
            return { ...pre, notifications }
        })
    }

    // Handle mark as read click
    const handleRead = async (items, status) => {
        let notificationIds = [];
        const copyItems = JSON.parse(JSON.stringify(items))
        if (copyItems.length) {
            for (const item of copyItems) { notificationIds.push(item.id); }
        }
        else if (copyItems.id) {
            notificationIds.push(copyItems.id)
        }
        let res = await NotificationService.changeReadStatus({ read_status: status, notificationIds });
        return res
    }
    const handleDeleteNotifications = async (items) => {
        let notificationIds = [];
        const copyItems = JSON.parse(JSON.stringify(items))
        if (copyItems.length) {
            for (const item of copyItems) { notificationIds.push(item.id); }
        }
        else if (copyItems.id) {
            notificationIds.push(copyItems.id)
        }
        let res = await NotificationService.deleteSelectedNotifications({ notificationIds });
        return res
    }

    // Handle popup toggle
    function handleClick(event) {
        if (anchorEl) { setAnchorEl(null); }
        else { fetchNotificationData(); setAnchorEl(event.currentTarget); }
    }

    // Handle popup close
    function handleClose(event) {
        if (anchorEl && anchorEl.contains(event.target)) {
            return;
        }
        setAnchorEl(null);
    }

    function handleOpenCustomDate(event) {
        if (anchorCustomDate) { setAnchorCustomDate(null); }
        else { setAnchorCustomDate(event.currentTarget); }
    }

    function handleCloseCustomDate(event) {
        if (anchorCustomDate && anchorCustomDate.contains(event.target)) {
            return;
        }
        setAnchorCustomDate(null);
    }
    const open = Boolean(anchorEl);
    const openCustomDate = Boolean(anchorCustomDate);

    const handleChange = (event) => {
        const nativeEvent = event.nativeEvent; // Native event'e erişim
        // Eğer tıklanan elemanın className "db-delete-dashboard-tab" içeriyorsa
        if (nativeEvent.target.classList.contains('db-delete-dashboard-tab') || nativeEvent.target.tagName === "path") {
            event.preventDefault(); // Varsayılan olayı engelle
            return; // Fonksiyonu sonlandır
        }

        // Eğer tıklanan eleman bu class'ı içermiyorsa, normal işlem devam eder
        if (event.target.value) {
            setSelectedDashboard(event.target.value);
            localStorage.setItem("dashboardTabId", event.target.value.id);
        }
    };

    const handleChangeDateValue = (event, newValue) => {
        setDateShowValue(newValue);
        updateDashboardDate(newValue)
        // fetchDashboardWidgets(newValue)
    };
    const handleSaveCustomDate = () => {
        if (customDateValue.start_date || customDateValue.end_date) {
            updateDashboardDate("custom")
        }
    };

    return (
        <div style={{ marginBottom: '1.5%' }}>
            <div className="db-row">
                <div className="db-hlabel" style={{ fontSize: '2em' }}>{`${t(label + 'HELLO')}, ${userName}`} &#128075;</div>
            </div>
            {/* <Notifications /> */}
            <div className="db-row db-notifications">
                <div>
                    {count > -1 && (<Button className={`db-page ${anchorEl ? "db-notification-button-active" : ""}`} onClick={handleClick}>
                        {/* {t('CONTENT.CREDENTIAL-TAB.LOCALE') === 'tr-TR' ?
                            <span><b>{count} Bildiriminiz</b> var.</span> :
                            <span>You have &nbsp;<b>{count} Notification{count > 1 ? 's' : ''}</b>.</span>
                        } */}
                        <div className='db-notification-container'>
                            <img src={NotificationIcon} />
                            <span className='db-notification-text' >{t(label + 'HAVE-NOTIFICATION')}</span>
                            <span className='db-notification-count' >{t(label + 'NOTIFICATIONS-COUNT', { count })}</span>
                        </div>
                        {count > 0 ? <div className='db-notification-circle'></div> : ""}
                    </Button>)}
                    {anchorEl && <DashBoardNotifications anchorEl={anchorEl} open={open} handleClose={handleClose} handleRead={handleRead}
                        label={label} notifications={notifications} handleDeleteNotifications={handleDeleteNotifications} />}
                    {/* <div className="db-page pending-action">
                        {t('CONTENT.CREDENTIAL-TAB.LOCALE') === 'tr-TR' ?
                            <span><span style={{ fontWeight: 'bold' }}>{quickInfo.queueCount} Aksiyon Beklemede</span>.</span> :
                            <span>You have &nbsp;<span style={{ fontWeight: 'bold' }}>{quickInfo.queueCount} Action{quickInfo.queueCount > 1 ? 's' : ''} Pending</span>.</span>
                        }
                    </div> */}
                    {/* {quickInfo.alertCount > -1 && (<Button className={`db-page`}>
                        <Link className='db-alert-link' to="/management/alert-management/alert-profile">
                            <div className='db-notification-container'>
                                <span className='db-notification-text' >{t(label + 'HAVE-ALERT')}</span>
                                <span className='db-notification-count' >{t(label + 'ALERT-COUNT', { count: quickInfo.alertCount })}</span>
                            </div>
                            {quickInfo.alertCount > 0 ? <div className='db-notification-circle'></div> : ""}
                        </Link>
                    </Button>)} */}
                </div>
                {/* <Link to="/autom-new"><Button><Add fontSize="small" /> &nbsp;{t(label + 'CREATE-AUTOM')}</Button></Link> */}
                {/* <Button id='new-autom-button' onClick={handleNewAutom}><Add fontSize="small" /> &nbsp;{t(label + 'CREATE-AUTOM')}</Button> */}
                <div className="db-label" style={{ color: '#B0B0B0' }}>{t(label + 'LAST-LOGIN')}: {convertToDateFormat(lastLoginTime, personalization.date_format)}</div>
            </div>
            <div className="db-page" style={{ padding: 0 }}>
                <div className='db-card-status-container'>
                    <div className="db-row quick-cards">
                        <div className="db-column db-qw green">
                            <div className="db-mincard">
                                <div>{t(label + 'AVAILABLE')}</div>
                                <div>{quickInfo.availableAutoms}</div>
                            </div>
                        </div>
                        <div className="db-column db-qw blue">
                            <div className="db-mincard">
                                <div>{t(label + 'PROGRESS')}</div>
                                <div>{quickInfo.inProgressAutoms}</div>
                            </div>
                        </div>
                        <div className="db-column db-qw orange">
                            <div className="db-mincard">
                                <div>{t(label + 'QUEUE')}</div>
                                <div>{quickInfo.queueCount}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='db-header-settings-container'>
                <div className='db-overview-container'>
                    <div className='db-overview-text'>{t(label + 'OVERVIEW')}</div>
                    <FormControl className='db-overview' variant="outlined" sx={{ width: '200px' }}>
                        <Typography className='db-overview-view-text' variant="body1" display="inline" sx={{ fontWeight: 'bold', paddingRight: '8px' }}>
                            {t(label + 'VIEW')}:
                        </Typography>
                        <Select
                            value={selectedDashboard?.name ? selectedDashboard.name : ''}
                            onChange={handleChange}
                            displayEmpty
                            inputProps={{ 'aria-label': 'View' }}
                            className='db-overview-type-input'
                            renderValue={(selected) => `${selected}`}
                            disabled={loading}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                },
                                getContentAnchorEl: null,
                                PaperProps: {
                                    style: {
                                        maxHeight: "200px"
                                    },
                                },
                            }}
                            sx={{
                                fontSize: '16px',
                                fontWeight: 'bold',
                                minWidth: '100px',
                                backgroundColor: 'white',
                                borderRadius: '4px',
                                '& .MuiSelect-select': {
                                    paddingRight: '24px',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                },
                            }}
                        >
                            {dashBoardTabs && dashBoardTabs.length ?
                                dashBoardTabs.map((dashboard, index) => {
                                    return <MenuItem
                                        key={`${index}-${dashboard.value}`}
                                        value={dashboard}>
                                        <span className='db-overview-select-item-bold-text'>
                                            <span>
                                                {dashboard?.name}
                                            </span>
                                            <RemoveCircleIcon className='db-delete-dashboard-tab' onClick={() => handleOpenRemove(true, dashboard)} />
                                        </span>
                                    </MenuItem>
                                }) : undefined
                            }
                            <MenuItem onClick={handleCreateDashboard}>
                                <span className='db-overview-select-item-bold-text'>{t(label + 'CREATE-NEW-DASHBOARD')}</span>
                            </MenuItem>
                        </Select>
                    </FormControl>
                    <Button className='db-refresh-button' disabled={loading} onClick={() => {
                        if (loading) return
                        handleRefresh()
                    }}>
                        {loading ? <CircularProgress size={16} /> : <RefreshIcon className='monitoring-refresh-icon' />}
                        <span className='db-refresh-data'>{t(label + 'REFRESH-DATA')}</span>
                    </Button>
                </div>
                <div className='db-configure-container'>
                    <Box sx={{ width: 'fit-content' }}>
                        <CustomTabs value={dateShowValue} onChange={handleChangeDateValue} indicatorColor="primary">
                            <CustomTab label="Weekly" value="weekly" />
                            <CustomTab label="Monthly" value="monthly" />
                            <CustomTab label="Yearly" value="yearly" />
                            <CustomTab label="Custom" value="custom" onClick={handleOpenCustomDate} />
                        </CustomTabs>
                        <Popper open={openCustomDate} anchorEl={anchorCustomDate} style={{ marginTop: 10, minWidth: 300 }} transition placement='bottom'>
                            {({ TransitionProps }) => (
                                <ClickAwayListener onClickAway={handleCloseCustomDate}>
                                    <Fade {...TransitionProps} timeout={350}>
                                        <Paper className='db-header-custom-date-popper'>
                                            <div className='db-header-custom-date-container'>
                                                <TextField value={customDateValue?.start_date}
                                                    type={"date"}
                                                    onChange={(e) => {
                                                        setCustomDateValue(pre => {
                                                            let newFilter = JSON.parse(JSON.stringify(pre))
                                                            newFilter = { ...newFilter, start_date: e.target.value }
                                                            return newFilter
                                                        });
                                                    }}
                                                    label="Select Start Date"
                                                    className='db-filter-autocomplete'
                                                    variant="outlined"
                                                    size="small"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                                <TextField value={customDateValue?.end_date}
                                                    type={"date"}
                                                    onChange={(e) => {
                                                        setCustomDateValue(pre => {
                                                            let newFilter = JSON.parse(JSON.stringify(pre))
                                                            newFilter = { ...newFilter, end_date: e.target.value }
                                                            return newFilter
                                                        });
                                                    }}
                                                    label="Select End Date"
                                                    className='db-filter-autocomplete'
                                                    variant="outlined"
                                                    size="small"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                                <Button className='db-next-button' onClick={handleSaveCustomDate}>
                                                    <span>{t(label + `SAVE`)}</span>
                                                </Button>
                                            </div>
                                        </Paper>
                                    </Fade>
                                </ClickAwayListener>
                            )
                            }
                        </Popper >
                    </Box>
                    {
                        <Button className='db-configure-button' onClick={() => {
                            handleOpenConfigure(!openConfigure)
                        }}>
                            <img src={ConfigureIcon} />
                            <span>{t(label + `${openConfigure ? 'CANCEL' : 'CONFIGURE'}`)}</span>
                        </Button>
                    }
                </div>
            </div>
        </div >
    );
}
export default DashBoardHeader;